/**
 * Стан списку живе в URL (§11 гайду): посилання на «прострочені інвойси,
 * сторінка 2» можна кинути колезі, а кнопка «назад» знімає останній фільтр,
 * а не викидає зі сторінки.
 */
export interface ListSearch {
	search?: string;
	status?: string;
	/** Поле сортування. Порожнє означає порядок за замовчуванням цього списку. */
	sort?: string;
	dir?: 'asc' | 'desc';
	/** Сторінка з одиниці. Перша в адресі не пишеться. */
	page?: number;
}

/** Валідатор для маршруту: сторонні параметри відкидаємо, свої нормалізуємо. */
export function validateListSearch(raw: Record<string, unknown>): ListSearch {
	const search = typeof raw.search === 'string' && raw.search.trim() !== '' ? raw.search.trim() : undefined;
	const status = typeof raw.status === 'string' && raw.status !== '' ? raw.status : undefined;
	const sort = typeof raw.sort === 'string' && raw.sort !== '' ? raw.sort : undefined;
	const dir = raw.dir === 'asc' || raw.dir === 'desc' ? raw.dir : undefined;
	const page = Number(raw.page);
	return { search, status, sort, dir, page: Number.isInteger(page) && page > 1 ? page : undefined };
}

/**
 * Сторінки з панеллю дії додають до стану списку вибраний рядок: панель має
 * переживати перезавантаження, а посилання — вести на конкретну ставку чи
 * дилера, а не просто в список.
 */
export interface SelectionSearch extends ListSearch {
	selected?: string;
}

export function validateSelectionSearch(raw: Record<string, unknown>): SelectionSearch {
	const base = validateListSearch(raw);
	const selected = typeof raw.selected === 'string' && raw.selected !== '' ? raw.selected : undefined;
	return { ...base, selected };
}

/**
 * Ставки й авто ще фільтруються за портом призначення (UN/LOCODE): «що їде в
 * Роттердам» і «що не дає прибрати Роттердам з довідника».
 */
export interface PortSearch extends SelectionSearch {
	destination?: string;
}

export function validatePortSearch(raw: Record<string, unknown>): PortSearch {
	const destination = typeof raw.destination === 'string' && /^[A-Z]{2}[A-Z0-9]{3}$/.test(raw.destination) ? raw.destination : undefined;
	return { ...validateSelectionSearch(raw), destination };
}
